import {LeafletFilteredMap} from "../elements/leafletFilteredMap";
import L from "leaflet";
import {toggleAreaExpend} from "../elements/inputs";
import {inputContainer, listposts} from "./filtre";

let contentResult = $("#content_result");

let mapContainer = $("#map_container");
let mapId = 'leaflet_filtered_map';
let mapDiv = $("#leaflet_filtered_map")
export let map;

//Init filter map
if ($('#leaflet_filtered_map').length) {
    map = new LeafletFilteredMap(mapId, {
        center: L.latLng(47.2186371, -1.5541362),
        zoom: 8,
        minZoom: 3,
        maxZoom: 20,
        layers: [L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png', {
            maxZoom: 20,
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        })]
    });

    //Event toggle map
    $('#toggle_leaflet_map').click(function () {
        toggleMap()
    }).keypress(function (e) {
        if (e.which === 13 || e.which === 32) {
            e.preventDefault()
            toggleMap();
        }
    })

    //Auto rezize map
    $(window).resize(function() {
        if (map) {
            resizeMap()
            map.resize()
        }
    });
}

function resizeMap() {
    if (!device.mobile()) {
        let topOffset;
        topOffset = $('.filter').height() + parseInt($('.entry-header').css('margin-bottom'))
        mapDiv.css({
            "top": -topOffset,
            "width": 'calc(100% + 50px - 15px)',
            "height": 'calc(100% + '+topOffset+'px)'
        })
    }
}

function toggleMap() {
    let toggle = $('#toggle_leaflet_map')
    toggleAreaExpend(toggle);
    let expanded = JSON.parse(toggle.attr('aria-expanded'));

    if (expanded) {
        $('html, body').animate({
            scrollTop: listposts.offset().top - 100
        }, 400);

        mapContainer.show()

        //Posts container classes
        contentResult.removeClass("col-12");
        contentResult.addClass("col-lg-6");
        //Posts size
        listposts.children().removeClass("col-xl-6");
        listposts.children().addClass("col-12");
        inputContainer.val("col-12 mb-6") //ajax classes

        toggle.addClass('checked')
        toggle.find('label').text("Fermer la carte")
    } else {
        mapContainer.hide()

        //Posts container classes
        contentResult.removeClass("col-lg-6");
        contentResult.addClass("col-12");
        //Posts classes
        listposts.children().removeClass("col-12");
        listposts.children().addClass("col-xl-6");
        inputContainer.val("col-xl-6 mb-6")  //ajax classes

        toggle.removeClass('checked')
        toggle.find('label').text("Afficher la carte")
    }

    // mapDiv.toggleClass('active')
    map.resize()
    resizeMap()
}
